import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'OfficeID',
    field: 'officeID',
    filter: 'text',
    hide: true,
  },
  {
    title: 'Office',
    field: 'officeName',
    filter: 'text',
    width: '350',
    searchable: true,
    navigate: true,
  },
  {
    title: 'Office Code',
    field: 'officeCode',
    filter: 'text',
    width: '150',
  },
  {
    title: 'Builder Code',
    field: 'builderCode',
    filter: 'text',
    width: '130',
  },
  {
    title: 'Account Manager',
    field: 'accountManagerNames',
    filter: 'text',
    width: '250',
    searchable: true,
  },
  {
    title: 'Office Type',
    field: 'officeTypeName',
    filter: 'text',
    searchable: true,
    width: '180',
  },

  {
    title: 'Contracts',
    field: 'contracts',
    filter: 'numeric',
    searchable: true,
    width: '110',
  },
  {
    title: 'Contacts',
    field: 'contacts',
    filter: 'numeric',
    width: '100',
    searchable: true,
  },
  {
    title: 'Projects',
    field: 'projects',
    filter: 'numeric',
    searchable: true,
    width: '100',
  },
  {
    title: 'Lots/Units',
    field: 'lots',
    filter: 'numeric',
    searchable: true,
    width: '110',
  },
  {
    title: 'Created On',
    field: 'createdOn',
    filter: 'text',
    width: '140',
    searchable: true,
  },

  {
    title: 'Status',
    field: 'status',
    filter: 'text',
    width: '120',
    searchable: true,
  },
];
